<template>
  <v-container
    fluid
    grid-list-md
    v-if="selectedPlan !== null && selectedPlan !== undefined"
  >
    <v-dialog v-model="dialogs.cancel" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">
          {{ $t("globals.cancel_wizard") }}
        </v-card-title>
        <v-card-text>
          {{ $t("views.contributionswizard.cancel_warning_message") }}
        </v-card-text>
        <v-card-actions>
          <v-btn color text @click="dialogs.cancel = false">
            {{ $t("globals.keep_working") }}
          </v-btn>
          <v-btn color="primary" @click="cancel">
            {{ $t("globals.cancel_anyway") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-stepper v-model="step" vertical>
      <v-stepper-step :complete="step > 1" :step="1">
        {{ $t("views.contributionswizard.choose_employer") }}
        <small>
          {{
            $t(
              "views.contributionswizard.choose_one_of_the_employers_in_the_list"
            )
          }}
        </small>
      </v-stepper-step>
      <v-stepper-content :step="1">
        <v-card>
          <v-form v-model="valid.chooseEmployer">
            <v-container fluid>
              <div class="row">
                <div class="col-12 col-md-4 col-lg-3">
                  <trans-select2
                    v-model="selections"
                    propertyName="employer"
                    :items="employers"
                    :label="$t('headers.members_management.Employer')"
                    field="Name"
                    itemValue="Id"
                    :class="'required'"
                    :rules="[$rules.required]"
                  ></trans-select2>
                </div>
              </div>
            </v-container>
          </v-form>
          <v-card-actions>
            <v-flex>
              <v-btn text @click="dialogs.cancel = true">
                {{ $t("globals.cancel") }}
              </v-btn>
              <v-btn
                :loading="loading"
                :disabled="
                  !valid.chooseEmployer ||
                    innerTerm === null ||
                    innerTerm === undefined
                "
                color="primary"
                @click="step = 2"
              >
                {{ $t("globals.continue") }}
              </v-btn>
            </v-flex>
          </v-card-actions>
        </v-card>
      </v-stepper-content>

      <v-stepper-step :complete="step > 2" :step="2">
        {{
          innerTerm !== null && innerTerm !== undefined
            ? $t(
                "views.contributionswizard.contributions_import_for_{0}_term",
                [innerTerm.Name + " " + innerTerm.Year]
              ) +
              " (" +
              innerTerm.StartDate.split("T")[0].replace(/-/g, "/") +
              " - " +
              innerTerm.EndDate.split("T")[0].replace(/-/g, "/") +
              ")"
            : $t("views.contributionswizard.contributions_import")
        }}
        <small>
          {{
            $t(
              "views.contributionswizard.download_and_use_a_data_template_in_xlsx_format_optional"
            )
          }}
        </small>
      </v-stepper-step>

      <v-stepper-content :step="2">
        <v-card>
          <v-container fluid>
            <v-row>
              <v-col class="col-auto">
                <v-btn
                  :loading="downloading"
                  color="success"
                  @click="downloadTemplate()"
                >
                  {{ $t("globals.download") }}
                </v-btn>
              </v-col>
              <v-col class="col-auto">
                <v-dialog v-model="dialogs.validationTips" width="500">
                  <template v-slot:activator="{ on }">
                    <v-btn color="success" dark v-on="on">
                      {{ $t("components.membersimportwizardcomponent.validation_rules") }}
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title
                      style="background:#4caf50;color: white;"
                      class="headline lighten-2"
                      primary-title
                    >
                      {{ $t("components.membersimportwizardcomponent.validation_rules") }}
                    </v-card-title>
                    <v-card-text>
                      <div style="padding-top:5px"></div>
                      <strong>
                        {{
                          $t("components.membersimportwizardcomponent.dates")
                        }}:
                      </strong>
                      {{
                        $t(
                          "components.membersimportwizardcomponent.columns_that_contain_date_values_must_have_their_format_cell"
                        )
                      }}
                      <v-divider />
                      <strong>
                        {{
                          $t(
                            "components.membersimportwizardcomponent.currency_format"
                          )
                        }}:
                      </strong>
                      {{
                        $t(
                          "components.membersimportwizardcomponent.currency_format_example"
                        )
                      }}
                      <v-divider />
                      <strong>
                        {{
                          $t(
                            "components.membersimportwizardcomponent.selection_columns"
                          )
                        }}:
                      </strong>
                      {{
                        $t(
                          "components.membersimportwizardcomponent.those_columns_should_contain_values_that_are_valid_names_eg"
                        )
                      }}
                      <v-divider />
                      <strong>
                        {{
                          $t(
                            "components.membersimportwizardcomponent.multi_select_columns"
                          )
                        }}:
                      </strong>
                      {{
                        $t(
                          "components.membersimportwizardcomponent.if_multiple_values_are_to_be_added_they_need_to"
                        )
                      }}
                      <v-divider />
                      <div v-if="mHeaders">
                        <strong>
                          {{
                            $t(
                              "components.membersimportwizardcomponent.required_columns"
                            )
                          }}:
                        </strong>
                        <span>
                          {{
                            mHeaders
                              .filter(
                                (f) => !f.isOptional && f.usedInBulkImport
                              )
                              .map((f) =>
                                $t("headers.members_wizard." + f.text)
                              )
                              .join(", ")
                          }}
                        </span>
                        <v-divider />
                        <strong>
                          {{
                            $t(
                              "components.membersimportwizardcomponent.optional_columns"
                            )
                          }}:
                        </strong>
                        <span>
                          {{
                            mHeaders
                              .filter((f) => f.isOptional && f.usedInBulkImport)
                              .map((f) =>
                                $t("headers.members_wizard." + f.text)
                              )
                              .join(", ")
                          }}
                        </span>
                      </div>
                    </v-card-text>

                    <v-divider></v-divider>
                    <v-card-actions>
                      <div class="flex-grow-1"></div>
                      <v-btn
                        color="primary"
                        text
                        @click="dialogs.validationTips = false"
                      >
                        {{ $t("globals.close") }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-col>
            </v-row>
          </v-container>
          <v-card-text>
            <div>
              <small>
                {{ $t("views.billingwizard.billing_import_subtitle") }}
              </small>
            </div>
            <file-uploader
              v-show="!confirmed"
              ref="uploader"
              :label="$t('views.billingwizard.billing_import_select')"
              accept=".xlsx"
              :uploading="uploading"
              :url="apiURL"
              v-on:upload-started="onUploadStarted"
              v-on:upload-error="onUploadError"
              v-on:upload-completed="onUploadCompleted"
            ></file-uploader>
            <span v-if="uploading">
              {{ $t("components.membersimportwizardcomponent.please_wait") }}
            </span>
            <div v-if="uploaded && uploadedOK">
              <v-banner
                icon="done"
                color="success"
                elevation="0"
                icon-color="white"
              >
                {{ $t(uploadResult) }}
              </v-banner>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-flex>
              <v-btn text @click="dialogs.cancel = true">
                {{ $t("globals.cancel") }}
              </v-btn>
              <v-btn :loading="uploading" text @click="step = 1">
                {{ $t("globals.back") }}
              </v-btn>
              <v-btn
                :loading="uploading"
                color="primary"
                @click="step = 3"
                :disabled="!uploaded || !uploadedOK"
              >
                {{ $t("globals.continue") }}
              </v-btn>
            </v-flex>
          </v-card-actions>
        </v-card>
      </v-stepper-content>
      <v-stepper-step :complete="step > 3" :step="3">
        {{ $t("components.membersimportwizardcomponent.match_columns") }}
        <small>
          {{ $t("views.contributionswizard.match_columns_subheader") }}
        </small>
      </v-stepper-step>

      <v-stepper-content :step="3">
        <v-card>
          <v-card-text>
            <v-container fluid>
              <v-row>
                <v-col>
                  <v-form v-model="valid.match">
                    <v-list>
                      <v-subheader>Required</v-subheader>
                      <v-container fluid>
                        <v-row>
                          <v-col
                            xs="12"
                            sm="6"
                            md="4"
                            lg="3"
                            v-for="item in requiredColumns"
                            :key="item"
                          >
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title
                                  v-text="item"
                                ></v-list-item-title>
                                <auto-select
                                  :value.sync="columnsAssociations[item]"
                                  :items="detectedColumns"
                                  :label="$t('components.membersimportwizardcomponent.detected')"
                                  :rules="[$rules.required]"
                                  class="required"
                                ></auto-select>
                              </v-list-item-content>
                            </v-list-item>
                          </v-col>
                        </v-row>
                      </v-container>
                      <v-divider></v-divider>

                      <v-subheader>Optional</v-subheader>
                      <v-container fluid>
                        <v-row>
                          <v-col
                            xs="12"
                            sm="6"
                            md="4"
                            lg="3"
                            v-for="item in optionalColumns"
                            :key="item"
                          >
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title
                                  v-text="item"
                                ></v-list-item-title>

                                <auto-select
                                  :clearable="true"
                                  :value.sync="columnsAssociations[item]"
                                  :items="detectedColumns"
                                  :label="$t('components.membersimportwizardcomponent.detected')"
                                ></auto-select>
                              </v-list-item-content>
                            </v-list-item>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-list>
                  </v-form>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-btn
                    color="primary"
                    @click="confirmMatch()"
                    :disabled="!valid.match || confirmed"
                    :loading="loading"
                  >
                    {{ $t("components.membersimportwizardcomponent.confirm_match") }}
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <div v-if="confirmed">
                    <v-banner
                      icon="done"
                      color="success"
                      elevation="0"
                      icon-color="white"
                    >
                      {{ $t("globals.success") }}
                    </v-banner>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <template v-for="(error, i) in errors">
                    <v-alert dense type="error" :key="i" dismissible>
                      {{ $t(error) }}
                    </v-alert>
                  </template>
                </v-col>
              </v-row>
            </v-container>
            <template v-for="(error, i) in uploadErrors">
              <v-alert dense type="error" :key="i" dismissible>
                {{ $t(error) }}
              </v-alert>
            </template>
          </v-card-text>
          <v-card-actions>
            <v-flex>
              <v-btn
                :loading="loading"
                text
                @click="dialogs.cancel = true"
                :disabled="confirmed"
              >
                {{ $t("globals.cancel") }}
              </v-btn>
              <v-btn :loading="loading" text @click="step = 2">
                {{ $t("globals.back") }}
              </v-btn>
              <v-btn
                :loading="loading"
                :disabled="!confirmed"
                color="primary"
                @click="finish"
              >
                {{ $t("globals.finish") }}
              </v-btn>
            </v-flex>
          </v-card-actions>
        </v-card>
      </v-stepper-content>
    </v-stepper>
    <error-handler :error="error"></error-handler>
  </v-container>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { planSetter } from "../../mixins/planSetter";
import ErrorHandler from "../../components/ErrorHandler";
import TransSelect2 from "../../components/TransSelect2";
import FileUploader from "../../components/FileUploader";
import { translate2 } from "../../trans2";
import AutoSelect from "../../components/AutoSelect";
import { sortAlphanum } from "@/alphanumericSort";
export default {
  name: "contributions-revise-wizard",
  props: ["term"],
  data() {
    return {
      selections: {},
      error: null,
      step: 1,
      valid: {
        chooseEmployer: false,
        match: false,
      },
      dialogs: {
        validationTips: false,
        cancel: false,
      },
      employers: [],
      loading: false,
      downloading: false,
      mHeaders: null,
      apiURL: null,
      confirmed: false,
      uploading: false,
      uploaded: false,
      uploadedOK: false,
      uploadErrors: [],
      columnsAssociations: {},
      requiredColumns: [],
      optionalColumns: [],
      detectedColumns: [],
      errors: [],
      guid: null,
      innerTerm: null,
    };
  },
  components: {
    ErrorHandler,
    TransSelect2,
    FileUploader,
    AutoSelect,
  },
  mixins: [planSetter],
  computed: {
    ...mapGetters("auth", ["isLoggedIn", "user", "role"]),
    ...mapGetters("common", { selectedPlan: "plan", settings: "settings" }),
    ...mapGetters("plansMembers", ["planOptions"]),
  },
  watch: {
    term: {
      handler(v) {
        this.innerTerm = v;
      },
    },
    selectedPlan: {
      handler() {
        this.loadPlanData();
      },
    },
    "selections.employer": {
      async handler(v) {
        if (this.term === null || this.term === undefined) {
          this.innerTerm = null;
        } else {
          this.innerTerm = this.term;
        }
        if (v !== null && v !== undefined) {
          try {
            this.loading = true;
            if (this.term === null || this.term === undefined) {
              this.innerTerm = (await this.getBillingImportTerm({
                planIdentityId: this.selectedPlan.Id,
                employerId: v.Id,
              })).data;
            }
            this.apiURL =
              this.settings.APIURL +
              "plans/" +
              this.selectedPlan.Id +
              "/employers-for-import/" +
              v.Id +
              "/contributions/terms/" +
              this.innerTerm.Id;
          } catch (error) {
            this.error = error;
          } finally {
            this.loading = false;
          }
        }
      },
    },
  },
  mounted() {
    if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
      this.loadPlanData();
    }
  },
  methods: {
    ...mapActions("plansMembers", [
      "getEmployersForImport",
      "getMembersBillingWizardColumns",
      "postConfirmMatchEmployer",
      "getBlobAsync",
      "getBillingImportTerm",
    ]),
    cancel() {
      this.dialogs.cancel = false;
      if (this.term === null || this.term === undefined) {
        this.$router.push({
          name: "contributions",
          params: { planId: this.selectedPlan.Id },
        });
      } else {
        this.$emit("close");
      }
    },
    finish() {
      // this.color = "success";
      // this.message = this.$t("globals.success");
      // this.snackbar = true;
      // setTimeout(()=>{
      if (this.term === null || this.term === undefined) {
        this.$router.push({
          name: "contributions",
          params: {
            planId: this.selectedPlan.Id,
          },
        });
      } else {
        this.$emit("close");
      }
      // }, 1500)
    },
    translate2(item, field) {
      return translate2(item, field);
    },
    async loadPlanData() {
      this.loading = true;
      try {
        this.employers = (await this.getEmployersForImport({
          planIdentityId: this.selectedPlan.Id,
        })).data.value.sort((a, b) => {
          const translatedA = a.Translations.filter(
            (o) => o.LanguageCode === this.language.language
          )[0].Name;
          const translatedB = b.Translations.filter(
            (o) => o.LanguageCode === this.language.language
          )[0].Name;
          return sortAlphanum(translatedA, translatedB);
        });

        this.mHeaders = (await this.getMembersBillingWizardColumns(
          this.selectedPlan.Id
        )).data.sort((a, b) => {
          return a.order - b.order;
        });
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    async downloadTemplate() {
      this.downloading = true;
      const url =
        "plans/" +
        this.selectedPlan.Id +
        "/employers-for-import/" +
        this.selections.employer.Id +
        "/template";

      const filename = "Template.xlsx";
      try {
        let blob = (await this.getBlobAsync({ url: url }))
          .data;

        const url2 = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url2;
        link.setAttribute("download", filename); //or any other extension
        link.setAttribute("id", "link1"); //or any other extension
        document.body.appendChild(link);
        link.click();
        var element = document.getElementById("link1");
        element.parentNode.removeChild(element);
      } catch (error) {
        this.error = error;
      }

      this.downloading = false;
    },
    async confirmMatch() {
      try {
        this.loading = true;
        //const url = "http://localhost:5011/MemberImport/Plan/" + this.selectedPlan.Id + "/Parse/" + this.guid;
        //const res = (await this.postAsync({url: url, payload: this.columnsAssociations})).data;
        const res = (await this.postConfirmMatchEmployer({
          guid: this.guid,
          employerId: this.selections.employer.Id,
          planIdentityId: this.selectedPlan.Id,
          termId: this.innerTerm.Id,
          payload: {
            Associations: this.columnsAssociations,
            IsRevised: true,
          },
        })).data;
        this.membersAdded = res.membersAdded;
        this.membersUpdated = res.membersUpdated;
        this.confirmed = true;
      } catch (error) {
        if (error.response) this.errors = error.response.data;
        else this.error = error;
      }
      this.loading = false;
    },
    onUploadStarted() {
      this.uploaded = false;
      this.uploading = true;
    },
    onUploadCompleted(res) {
      this.uploaded = true;
      this.uploadedOK = true;
      this.uploading = false;
      /*this.uploadResult =
        "Upload successful. The uploaded data were successfully imported. Note that during the process " +
        res.data.membersAdded +
        " new members were created. Navigate to members records table to review the updated members data.";*/
      this.requiredColumns = res.required;
      this.optionalColumns = res.optional;
      this.detectedColumns = res.detected;
      this.columnsAssociations = res.associations;
      this.guid = res.guid;
      this.uploadResult =
        "Upload successful. Match actual with detected columns and confirm";
    },
    onUploadError(err) {
      this.uploaded = true;
      this.uploadedOK = false;
      this.uploading = false;
      this.uploadErrors = err.response.data;
    },
    // reset() {
    //   this.$refs.uploader.reset();
    //   this.e6 = 3;
    //   this.uploaded = false;
    //   this.uploadedOK = false;
    //   this.uploadResult = "";
    //   this.confirmed = false;
    //   this.uploadErrors = [];
    //   this.errors = [];
    // },
  },
};
</script>
